export const FETCH_REGION_URL = `${process.env.REACT_APP_API_URL}/regions`;
export const CREATE_REGION_URL = `${process.env.REACT_APP_API_URL}/regions/create`;
export const UPDATE_REGION_URL = `${process.env.REACT_APP_API_URL}/regions`;
export const DELETE_REGION_URL = `${process.env.REACT_APP_API_URL}/regions`;
